<ng-container *ngFor="let i of [].constructor(quantity)">
  <div class="card">
    <div class="card-inner content-placeholder">
      <svg height="0" width="0">
        <defs>
          <clipPath id="svg-placeholder">
            <rect x="5" y="5" rx="4" ry="4" width="50vw" height="10" />
            <rect x="5" y="20" rx="4" ry="4" width="80vw" height="10" />

            <rect x="5" y="50" rx="4" ry="4" width="20vw" height="20" />
            <rect x="5" y="80" rx="4" ry="4" width="80vw" height="50" />

            <rect x="5" y="150" rx="4" ry="4" width="20vw" height="20" />
            <rect x="5" y="180" rx="4" ry="4" width="80vw" height="50" />

            <rect x="5" y="250" rx="4" ry="4" width="20vw" height="20" />
            <rect x="5" y="280" rx="4" ry="4" width="80vw" height="50" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
</ng-container>